// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Finito from "modules/finito-module";
import BaoDialog from "./../factories/bao-dialog";
import TabController from "./../factories/tab-controller";
import TabPage from "./../factories/tab-page";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import "./../bindings/bao-number-box";
import "./../bindings/bao-tabs";
function StateViewModel(tabPage) {
    var self = this;
    self.TabPage = tabPage;
    self.TabController = new TabController(false);
    self.StateColors = ko.observable();
    self.Color = ko.observable();
    SearchPaging.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.StateText())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.StateNumber = ko.observable();
    self.StateText = ko.observable();
    self.StateText1 = ko.observable();
    self.StateText2 = ko.observable();
    self.StateText3 = ko.observable();
    self.StateText4 = ko.observable();
    self.StateText5 = ko.observable();
    self.StateText.subscribe(function () {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.StateText1(self.StateText());
                break;
            case 2:
                self.StateText2(self.StateText());
                break;
            case 3:
                self.StateText3(self.StateText());
                break;
            case 4:
                self.StateText4(self.StateText());
                break;
            case 5:
                self.StateText5(self.StateText());
                break;
        }
    });
    self.Translate = function () {
        var translateDialog = new TranslateDialogViewModel(self.StateText1, self.StateText2, self.StateText3, self.StateText4, self.StateText5);
        translateDialog.Open().then(function () { });
    };
    self.StateOrgUnitTab;
    self.loaded = function () {
        this.InitPaging();
        this.TabPage.DirtyFlag.reset();
        this.TabPage.IsLoading(false);
        this.Focus();
        Bao.post("MasterData/State/GetStateColors", JSON.stringify({}), function (result) {
            if (result != null) {
                self.StateColors(result.Colors);
            }
        });
        self.StateOrgUnitTab = new TabPage(null);
        self.StateOrgUnitTab.Url("MasterData/StateOrgUnitTab");
        self.StateOrgUnitTab.IsClosable(false);
        self.StateOrgUnitTab.Visible(true);
        self.TabController.AddTab(self.StateOrgUnitTab);
    };
    StateViewModel.prototype.BaseSave = StateViewModel.prototype.Save;
    StateViewModel.prototype.Save = function () {
        var self = this;
        self.TabPage.IsLoading(true);
        Bao.post(self.SaveUrl, JSON.stringify({
            model: self.MinimizeEntity()
        }), function (value) {
            self.SaveTime(value.Result);
        }).then(function (data) {
            return self.StateOrgUnitTab.ViewModel().Commit(data.Result);
        }).then(function () {
            return self.PerformRefresh();
        });
    };
}
Bao.inherit(StateViewModel, SearchPaging);
StateViewModel.prototype.PrimaryKey = "InfoStateId";
StateViewModel.prototype.RefreshUrl = "State/Get";
StateViewModel.prototype.SaveUrl = "State/Save";
StateViewModel.prototype.DeleteUrl = "State/Delete";
StateViewModel.prototype.IsInUseUrl = "State/IsInUse";
StateViewModel.prototype.PermissionForward = "StateForward";
StateViewModel.prototype.PermissionBackward = "StateBackward";
StateViewModel.prototype.PermissionSave = "StateSave";
StateViewModel.prototype.PermissionRefresh = "StateRefresh";
StateViewModel.prototype.PermissionDelete = "StateDelete";
export default StateViewModel;